import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {appContext} from '../../../../app.context';
import {ArchiSmallERRORS} from '../../../../commons/errors';

class ConservazioneCaricaDocumentoFatturaPassivaStep2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }

    $scope.documentTypes = ['Fattura', 'Parcella', 'Nota di Credito', 'Nota di Debito', 'Acconto/Anticipo'];

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.years = [];
    const curr_year = new Date().getFullYear();
    for (let i = curr_year - 1; i <= curr_year; i++) {
      $scope.years.push(i);
    }
    const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {
      anno: number,
      scadenza: string
    }[];
    if (years) {
      for (let year of years) {
        if (new Date(year.scadenza) > new Date()) {
          $scope.years.push(year.anno);
        }
      }
    }

    $scope.fornitore = {};
    $scope.anagraficaIsNew = true;
    $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    let isNomeFornitoreDisabled;
    let isCognomeFornitoreDisabled;
    let isRagioneSocialeFornitoreDisabled;
    let isFornitoreCFDisabled;
    let isFornitorePIVADisabled;

    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', {'classeDocumentale': $scope.classeDocumentale});
    };

    // <editor-fold desc='openWorkerModal'>
    $scope.openWorkerModal = (size) => {

      if ($scope.anagraficaIsNew) {
        $scope.saveAnagrafica();
      }

      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');
      $scope.settings.dataProtocollo = $filter('date')($scope.settings.dataProtocollo, 'yyyy-MM-dd');
      // $scope.settings.fornitoreDenominazione = $scope.fornitore.anagrafica.full_name;

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerVersamentoModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          },
          classeDocumentale: () => {
            return 'fattura_passiva';
          }
        }
      });
    };
    // </editor-fold>

    $scope.saveAnagrafica = () => {
      let anagrafica = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.fornitoreNome,
        cognome: $scope.settings.fornitoreCognome,
        company_name: $scope.settings.fornitoreDenominazione,
        fiscal_code: $scope.settings.fornitoreCodiceFiscale,
        piva: $scope.settings.fornitorePIVA,
        type: $scope.settings.fornitoreDenominazione !== '' ? 2 : `${$scope.settings.fornitoreNome} ${$scope.settings.fornitoreCognome}`.trim() !== '' ? 1 : 2
      };

      ArchiSmallServices.insertAnagrafica(anagrafica)
        .then((response: any) => {
          // ??
        }, (error) => {
          if (error.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
            $rootScope.alert('error', 'Anagrafica già esistente');
          }
        });
    };

    $rootScope.formsubmitted = false;

    // <editor-fold desc='setConservazioneSettings'>
    $scope.setConservazioneSettings = () => {
      $scope.settings.fornitoreDenominazione = $scope.fornitore.anagrafica;
      let classeDocumentale = $scope.settings.classeDocumentale.key;
      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ??
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.fornitore.anagrafica = $scope.settings.fornitoreDenominazione;
            isNomeFornitoreDisabled = $scope.settings.fornitoreNome !== '' && $scope.settings.fornitoreNome !== undefined;
            isCognomeFornitoreDisabled = $scope.settings.fornitoreCognome !== '' && $scope.settings.fornitoreCognome !== undefined;
            isRagioneSocialeFornitoreDisabled = $scope.settings.fornitoreDenominazione !== '' && $scope.settings.fornitoreDenominazione !== undefined;
            isFornitoreCFDisabled = $scope.settings.fornitoreCodiceFiscale !== '' && $scope.settings.fornitoreCodiceFiscale !== undefined;
            isFornitorePIVADisabled = $scope.settings.fornitorePIVA !== '' && $scope.settings.fornitorePIVA !== undefined;

          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
    }

    $scope.dpOpened = {
      dataDocumento: false,
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    /* tslint:disable:no-string-literal */
    $scope.autoOpen = ($event, opened) => {
      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    /* tslint:enable:no-string-literal */
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.getAnagraficaTypeaheadValues = () => {
      ArchiSmallServices.getAnagraficaTypeaheadValues()
        .then((response: any) => {
          $scope.anagrafica = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getAnagraficaTypeaheadValues();

    $scope.autocompleteFields = (item) => {
      if (item !== undefined && typeof item === 'object') {

        if (item._id === -1) {
          $scope.settings.fornitoreNome = '';
          $scope.settings.fornitoreCognome = '';
          $scope.settings.fornitoreDenominazione = '';
          $scope.settings.fornitorePIVA = '';
          $scope.settings.fornitoreCodiceFiscale = '';
          isNomeFornitoreDisabled = false;
          isCognomeFornitoreDisabled = false;
          isRagioneSocialeFornitoreDisabled = false;
          isFornitoreCFDisabled = false;
          isFornitorePIVADisabled = false;
          $scope.anagraficaIsNew = true;
        } else {
          $scope.settings.fornitoreNome = item.nome;
          $scope.settings.fornitoreCognome = item.cognome;
          $scope.settings.fornitoreDenominazione = item.company_name;
          $scope.settings.fornitorePIVA = item.piva;
          $scope.settings.fornitoreCodiceFiscale = item.fiscal_code;
          isNomeFornitoreDisabled = item.nome !== '' && item.nome !== undefined;
          isCognomeFornitoreDisabled = item.cognome !== '' && item.cognome !== undefined;
          isRagioneSocialeFornitoreDisabled = item.company_name !== '' && item.company_name !== undefined;
          isFornitoreCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
          isFornitorePIVADisabled = item.piva !== '' && item.piva !== undefined;
          $scope.anagraficaIsNew = false;
        }
      }
    };

    $scope.clear = ($event, $select) => {
      UISelectService.clear($event, $select);

      $scope.fornitore.anagrafica = '';
      $scope.settings.fornitoreNome = '';
      $scope.settings.fornitoreCognome = '';
      $scope.settings.fornitoreDenominazione = '';
      $scope.settings.fornitorePIVA = '';
      $scope.settings.fornitoreCodiceFiscale = '';
      isNomeFornitoreDisabled = false;
      isCognomeFornitoreDisabled = false;
      isRagioneSocialeFornitoreDisabled = false;
      isFornitoreCFDisabled = false;
      isFornitorePIVADisabled = false;
      $scope.anagraficaIsNew = false;
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.isNomeFornitoreDisabled = () => {
      return isNomeFornitoreDisabled;
    };
    $scope.isCognomeFornitoreDisabled = () => {
      return isCognomeFornitoreDisabled;
    };
    $scope.isRagioneSocialeFornitoreDisabled = () => {
      return isRagioneSocialeFornitoreDisabled;
    };
    $scope.isFornitoreCFDisabled = () => {
      return isFornitoreCFDisabled;
    };
    $scope.isFornitorePIVADisabled = () => {
      return isFornitorePIVADisabled;
    };
  }
}

export const ConservazioneCaricaDocumentoFatturaPassivaStep2Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-fattura-passiva-step2.html'),
  controller: ConservazioneCaricaDocumentoFatturaPassivaStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-fattura-passiva-step2/conservazione-carica-documento-fattura-passiva-step2.ts